import { pushAxonEvent } from '@/utils/axonTrack'

export function useAxonSignUp() {
  /** 注册转化:/member/active 首次成功时触发,IsActive 门控保证设备维度只报一次 */
  function reportSignUp() {
    pushAxonEvent('sign_up', {})
  }

  return { reportSignUp }
}
